import OneSchemaImporter from '@oneschema/react';
import { JSONParser } from '@streamparser/json-whatwg';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useState } from 'react';
import { useNotificationStore } from '../../../components/notificationStore';
import { useUserStore } from '../../../components/userStore';

const EnrolleeFileUpload = () => {
	const { user } = useUserStore();
	const [isOSOpen, setOSOpen] = useState(false);
	const { showSuccess, showError } = useNotificationStore();

	const tokenQuery = useQuery({
		queryKey: ['one-schema-token', user.id],
		queryFn: async () => {
			const { data } = await axios.get(`/coords/${user.id}/one-schema-token`);
			return data;
		},
	});

	const handleOSError = (error) => {
		setOSOpen(false);
		showError(`Problem with import! ${error?.message}`);
	};

	const handleOSData = async (data) => {
		const { sheet_id, embed_id, template_key } = data;
		try {
			const response = await axios.post(
				`/coords/${user.id}/one-schema-export`,
				{
					sheet_id,
					embed_id,
					template_type: template_key,
				},
				{ adapter: 'fetch', responseType: 'stream' },
			);

			const jsonParser = new JSONParser({
				emitPartialTokens: false,
				emitPartialValues: false,
				keepStack: false,
				paths: ['$.*'],
			});
			const reader = response.data.pipeThrough(jsonParser).getReader();
			while (true) {
				const { done, value } = await reader.read();
				const obj = value?.value;
				if (done) break;
				if (obj) {
					// Process the received object
					// console.log(obj);
					if (obj?.type === 'error') {
						showError(obj.message);
					} else {
						showSuccess(obj.message);
					}
				}
			}
		} catch (err) {
			showError(`Problem with upload! ${err?.message}`);
		}

		// .then(({ data }) => {
		// 	data.on('data', (chunk) => {
		// 		console.log(chunk);
		// 	});
		// 	data.on('end', () => {
		// 		console.log('done');
		// 	});
		// 	data.on('error', (err) => {
		// 		console.log('err', err);
		// 	});
		// 	// console.log(data);
		// 	// showSuccess('File import successful');
		// })
		// .catch((error) => {
		// 	console.log(error);
		// 	showError(`Problem with upload! ${error?.message}`);
		// });
	};

	return (
		<>
			<h1>Eligible Enrollees File Upload</h1>
			<p>
				Tandem uses a HIPAA compliant third-party application to validate import
				files for data conformance. Click File Upload to load and process the
				file. If there are errors, please complete the following two steps:
			</p>
			<ol className="m-4 list-decimal list-outside">
				<li className="mx-4">
					Fix the errors and resubmit the file. The Enrollee files will process
					on Friday evening.
				</li>
				<li className="mx-4">
					Submit a support ticket via email to{' '}
					<a href="mailto:support@nowintandem.com">support@nowintandem.com</a>.
				</li>
			</ol>
			<p className="text-sm">
				* Eligible Enrollee files should be submitted on a monthly basis to keep
				patient attribution up to date and no longer than 90 days.
			</p>
			<button
				className="mt-4 btn btn-primary btn-wide"
				onClick={() => setOSOpen(true)}
				disabled={!tokenQuery.isFetched}
			>
				File Upload
			</button>
			{tokenQuery.isFetched && (
				<OneSchemaImporter
					isOpen={isOSOpen}
					onRequestClose={() => setOSOpen(false)}
					clientId={tokenQuery?.data?.iss}
					userJwt={tokenQuery?.data?.token}
					templateKey="ilos_enrollees"
					importConfig={{ type: 'local', metadataOnly: false }}
					devMode={process.env.NODE_ENV !== 'production'}
					className="oneschema-importer"
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100vw',
						height: '100vh',
						zIndex: 1000,
					}}
					onSuccess={handleOSData}
					onCancel={() => setOSOpen(false)}
					onError={handleOSError}
				/>
			)}
		</>
	);
};

export default EnrolleeFileUpload;
